//#region src/function/to-value.ts
/**
* Unwrap a {@link ValueOrFunction} to its value, calling the function if that is what was given.
*
* A function that throws answers `undefined`: callers may be inside a synchronous pass where one bad producer must not
* fail the whole pass, and a value that cannot be produced is unusable anyway.
*
* @example
*   ```ts
*   toValue('https://a.example'); // 'https://a.example'
*   toValue(() => current?.url); // whatever `current.url` is right now
*   toValue(undefined); // undefined
*   ```;
*
* @internal
*/
function toValue(value) {
	if (typeof value !== "function") return value;
	try {
		return value();
	} catch {
		return;
	}
}
//#endregion
export { toValue };

//# sourceMappingURL=to-value.js.map